import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';
import type { FamilyItem } from 'reactApp/modules/family/family.types';

export class FamilyAcceptInviteAPICall extends APICallV4<FamilyItem> {
    _method = 'family/accept';
    _type: Method = 'post';
    _retriesCount = 0;
}
